import { MediaContentDTO } from "@touche-lts/panel-ui/dist";
import { ProductsTableEntityDTO } from "./products-table-entity";
import { StoreDTO } from "./store";

export enum StatisticsStores {
  ALLSTORES = 'All stores'
}

export enum StatisticsDatePeriod {
  WEEK = 'Past week',
  MONTH = 'Past month',
  YEAR = 'Past year'
}

export interface StatisticsHighlights {
  customerCount: number;
  orderCount: number;
  storeCount: number;
  totalRevenue: number;
  stores: number;
  activeProducts: number;
  productsSold: number;
  orders: number;
  visitingUsers: number;
  bestSellingProduct: ProductsTableEntityDTO;
  bestStore: StoreDTO;
  totalGeminiTokens: number;
  totalVideo: number;
}

export interface StoreAdminHighlightsDTO {
  totalOrders: number;
  totalRevenue: number;
  totalProducts: number;
  totalVisitors: number;
  productsSold: number;
  bestSellingProduct: ProductsTableEntityDTO;
  periodStart: string;
  periodEnd: string;
}

export interface StatisticsPayloadDTO {
  dateEnd?: string;
  dateStart?: string;
  name?: string;
  revenueTodayMax?: number;
  revenueTodayMin?: number;
  revenueTotalMax?: number;
  revenueTotalMin?: number;
}

export interface StatisticsTableEntryDTO {
  id: number;
  version: number;
  createdAt: string;
  lastUpdated: string;
  date: string;
  master: boolean;
  revenueTotal: number;
  revenueToday: number;
  activeSkus: number;
  images: MediaContentDTO[];
  productName: string;
  /** Present on some aggregate / all-stores rows from the API */
  productCount?: number;
  storeIds?: number[];
  sold?: number;
  stock?: number;
  variants?: number;
}
